import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const AppleScaleMedium = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M16.3653 6.25549C14.4755 6.25549 13.6768 7.18355 12.3606 7.18355C11.0107 7.18355 9.98143 6.26112 8.34468 6.26112C6.74167 6.26112 5.0318 7.26792 3.94625 8.98342C2.42199 11.402 2.68072 15.9579 5.14991 19.8389C6.03297 21.2281 7.21414 22.7862 8.7609 22.803H8.78902C10.1333 22.803 10.5326 21.8975 12.3831 21.8862H12.4113C14.2336 21.8862 14.5992 22.7974 15.9379 22.7974H15.966C17.5128 22.7805 18.7558 21.0538 19.6388 19.6701C20.2744 18.6746 20.5107 18.174 21 17.0491C17.4284 15.6542 16.8547 10.4458 20.3869 8.44908C19.307 7.05981 17.794 6.25549 16.3653 6.25549Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <path
                d="M15.9483 1.19971C14.8234 1.27845 13.5128 2.01527 12.7423 2.97708C12.0448 3.84889 11.4711 5.14254 11.6961 6.39682H11.7861C12.9841 6.39682 14.2103 5.65438 14.9246 4.70382C15.6164 3.79827 16.1395 2.51586 15.9483 1.19971Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Apple'
);
export default AppleScaleMedium;
